import { axiosObject } from "../config";

export default function getMultipleFilesByOwnerIdentifier(
  owner_identifier: string,
  owner_service: string
) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/files/_read";
    let payload = {
      filterBy: [
        {
          attribute: "owner_identifier",
          op: "eq",
          value: owner_identifier,
        },
        {
          attribute: "owner_service",
          op: "eq",
          value: owner_service,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data?.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
